import { getDecodedNetworkId } from '@ms/yammer-telemetry-store';

type GetNetworkId = () => number | undefined;
export const getNetworkId: GetNetworkId = () => {
  const networkId = getDecodedNetworkId() ?? '';

  const id = parseInt(networkId);

  if (isNaN(id)) {
    return undefined;
  }

  return id;
};
